import React from "react";
import { useTranslation } from "react-i18next";

const PRESENTATION_URL = "/downloads/spanjolska-valladolid.pptx";

export default function SpanishPresentation() {
  const { t } = useTranslation();

  return (
    <section id="spanish-presentation" className="section section-alt">
      <div className="container">
        <header className="section-header">
          <h2>{t("spanishPresentation.sectionTitle")}</h2>
          <p>{t("spanishPresentation.sectionSubtitle")}</p>
        </header>
        <div className="spanish-presentation-box">
          <p className="spanish-presentation-intro">
            {t("spanishPresentation.intro")}
          </p>
          <a
            href={PRESENTATION_URL}
            download="Spanjolska-Valladolid-prezentacija.pptx"
            className="btn primary spanish-presentation-download"
          >
            {t("spanishPresentation.download")}
          </a>
        </div>
      </div>
    </section>
  );
}
